import * as React from 'react';
import UrlPaths from '@studio/constants/url-paths';
import { useAppRefresh } from '@studio/storeV2/authentication/hooks/use-app-refresh';

const AuthProvider = ({ children }: { children?: React.ReactNode }) => {
  const { refresh } = useAppRefresh();

  React.useEffect(() => {
    if (
      !(
        [
          UrlPaths.UPLOADER.ROOT,
          UrlPaths.UPLOADER.RESET_PASSWORD,
          UrlPaths.UPLOADER.SUCCESS,
          UrlPaths.UNREGISTER.ROOT,
          UrlPaths.UNREGISTER.SUCCESS,
        ] as string[]
      ).some((url) => window.location.pathname.endsWith(url))
    ) {
      void refresh();
    }
  }, [refresh]);

  return <React.Fragment>{children}</React.Fragment>;
};

AuthProvider.displayName = 'AuthProvider';

export default AuthProvider;
